var isNumber = require('./isNumber')

function isNumberFinite (obj) {
  return isNumber(obj) && isFinite(obj)
}

module.exports = isNumberFinite



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isFinite.js
// module id = 520
// module chunks = 98